import React from 'react';
import { Dialog, DialogTitle, DialogContent, DialogActions, Button, Stack, Typography, Tooltip } from '@mui/material';
import AppDocuServiceCall from '../_Utils/AppDocuServiceCall';
import { handleDownloadCalibration, calibrationStatusOptions } from '../_Utils/AppDocuCommon';
import EditCalibrationDialog from '../Calibration_Components/EditCalibrationDialog';

export default class DialogCalibrationDetails extends React.Component {
  state = { loading: false, calib: null, itemDataToEdit: null };

  async loadData() {
    this.setState({ loading: true });
    try {
      const res = await AppDocuServiceCall.getCalibration(this.props.calibrationId);
      const calib = res.data.calibration || null;
      this.setState({ calib, loading: false });
    } catch (e) {
      this.setState({ loading: false });
    }
  }

  async componentDidUpdate(prevProps) {
    if (this.props.calibrationId && this.props.calibrationId !== prevProps.calibrationId) {
      await this.loadData();
    }
  }

  renderValue = value => value ? (
    <Typography variant="body1" sx={{ color: 'grey.900' }}>{value}</Typography>
  ) : (
    <Typography variant="body2" sx={{ color: '#bdbdbd', textTransform: 'uppercase' }}>undefined</Typography>
  );

  renderStatus = (status) => {
    if (!status) return this.renderValue();
    const found = calibrationStatusOptions.find(opt => opt.name === status);
    if (!found) return this.renderValue(status);
    const bg = found.color || '#888';
    const tip = found.comment || found.name;
    return (
      <Tooltip 
        title={tip} 
        arrow 
        PopperProps={{ modifiers: [{ name: 'offset', options: { offset: [0, -10] } }] }}
        componentsProps={{ tooltip: { sx: { bgcolor: bg, color: '#fff', '& .MuiTooltip-arrow': { color: bg } } } }}>
        <span style={{ 
          display: 'inline-block', 
          padding: '2px 10px', 
          borderRadius: 6, 
          background: bg, 
          color: '#fff', 
          fontWeight: 700, 
          fontSize: 13 
        }}>{found.name}</span>
      </Tooltip>
    );
  }

  render() {
    const { calib, loading } = this.state;
    const { open, onClose } = this.props;
    return (
      <>
        <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
          <DialogTitle>Calibration Details</DialogTitle>
          <DialogContent>
            {loading && <Typography>Loading...</Typography>}
            {calib && (
              <Stack spacing={2}>
                <Typography variant="h5" sx={{ fontWeight: 700, color: 'primary.main' }}>{calib.original_filename}</Typography>
                <div>
                  <Typography variant="caption" sx={{ color: 'grey.700' }}>Name</Typography>
                  {this.renderValue(calib.name)}
                </div>
                <div>
                  <Typography variant="caption" sx={{ color: 'grey.700' }}>Com Brand</Typography>
                  {this.renderValue(calib.com_brand)}
                </div>
                <div>
                  <Typography variant="caption" sx={{ color: 'grey.700' }}>ECU Type</Typography>
                  {this.renderValue(calib.ecu_type)}
                </div>
                <div>
                  <Typography variant="caption" sx={{ color: 'grey.700' }}>Injector</Typography>
                  {this.renderValue(calib.injector)}
                </div>
                <div>
                  <Typography variant="caption" sx={{ color: 'grey.700' }}>FW Version</Typography>
                  {this.renderValue(calib.fw_version)}
                </div>
                <div>
                  <Typography variant="caption" sx={{ color: 'grey.700' }}>SW Version</Typography>
                  {this.renderValue(calib.sw_version)}
                </div>
                <div>
                  <Typography variant="caption" sx={{ color: 'grey.700' }}>Usage Info</Typography>
                  {(calib.usage_info || '').split(/\r?\n|,/).filter(Boolean).length === 0 ? (
                    this.renderValue()
                  ) : (   
                    <ul style={{ margin: 0, paddingLeft: 18 }}>
                      {(calib.usage_info || '').split(/\r?\n|,/).filter(Boolean).map((acc, i) => (
                        <li key={i} style={{ color: '#222', fontSize: 15 }}>{acc.trim()}</li>
                      ))}
                    </ul>
                  )}
                </div>
                <div>
                  <Typography variant="caption" sx={{ color: 'grey.700' }}>Status:{' '}</Typography>
                  {this.renderStatus(calib.status)}
                </div>
              </Stack>
            )}
          </DialogContent>
          <DialogActions>
            {calib && (
                <Button onClick={() => handleDownloadCalibration(calib)}>Download</Button>
            )}
            {this.props.showEdit && calib && (
                <Button onClick={() => this.setState({ itemDataToEdit: calib })}>Edit</Button>
            )}
            <Button onClick={onClose}>Close</Button>
          </DialogActions>
        </Dialog>
        <EditCalibrationDialog
          itemId={this.state.itemDataToEdit ? this.state.itemDataToEdit.id : null}
          onClose={() => this.setState({ itemDataToEdit: null })}
          onItemsChange={() => this.loadData()}
        />        
      </>
    );
  }
}
